import packageData from '../package.json';

const appConfig = {
    mode : 'dev',
    name : '',
    desc : '',
    version : packageData.version,
    apiHostname : '',
    apiBaseUrl : '',

    title : {
        // prefix | suffix
        additiveType : 'prefix',
        additive : '师讯-'
    },

    qcloud : {},
    wechat : {
        enableJSSDK : false,
        jsApiList: [
            'onMenuShareAppMessage', 'onMenuShareTimeline',
            'onMenuShareQQ', 'onMenuShareWeibo', 'onMenuShareQZone',
            'updateAppMessageShareData', 'updateTimelineShareData',
            'chooseWXPay', 'getLocation', 'scanQRCode'
        ],
        autoLogin : true,
        defaultDescription : '早幼托内容服务平台资源每周更新，快去了解'
    },
    themes : {
        'orangeTheme' : 'theme/orangeTheme.css'
    },
    messageMap : {
        networkError : '网络出错，请稍后再试。',
        networkTimeout : '网络通讯超时，请尝试稍后重试。',
        saveSuccess : '保存成功！',
        sessionTimeout : '会话超时',
        permissionDeny : '没有相关操作权限',
        methodNotSupport : '网络通讯失败：method not support',
        serviceError : '网络通讯失败：Service error',
    },
    promotion : {
        /* type: Number  day */
        expires : 1 /24 /2
    },
    questionnaire : {
        /* type: Number  minute */
        afterBindPhone : 10
    },
    phoneBindingTips : '根据《中华人民共和国网络安全法》要求，自2017年6月1日起使用信息发布、即时通讯等互联网服务需进行身份信息验证。' +
        '为保障您的使用体验，建议尽快完成手机号绑定验证，感谢您的理解和支持！'
};

let externalAppConfig = {
    testing : {
        qcloud : {
            video : {
                appId : '1255764641',   // 测试
                // appId : '1304629723',   // 测试(新腾讯云账号)
                // appId : '1252682191',   // 正式
            }
        }
    },
    production : {
        qcloud : {
            video : {
                appId : '1252682191'
            }
        }
    }
};

// env
if (process.env.NODE_ENV === 'production')
{
    if (process.env.VUE_APP_MODE === 'prod')        // production 生产环境
    {
        appConfig.apiHostname = 'api.shixun365.com';
        appConfig.qcloud = externalAppConfig.production.qcloud;
    }
    else if (process.env.VUE_APP_MODE === 'test')   // test 测试环境
    {
        appConfig.apiHostname = 'jee.shixun365.com';
        appConfig.qcloud = externalAppConfig.testing.qcloud;
    }
    appConfig.apiBaseUrl = '//' + appConfig.apiHostname + '/shixun/';
}
else if (process.env.NODE_ENV === 'development')  // development 开发环境
{
    appConfig.apiHostname = 'localhost';
    appConfig.qcloud = externalAppConfig.testing.qcloud;
    appConfig.apiBaseUrl = '//' + appConfig.apiHostname + '/shixun-mobile-2020/api/shixun/';  // for browser
    // appConfig.apiBaseUrl = '//jee.shixun365.com/shixun/';     // for wechat app
}

export default appConfig;
